import { render, staticRenderFns } from "./mbManage.vue?vue&type=template&id=391ea1c4&scoped=true&"
import script from "./mbManage.vue?vue&type=script&lang=js&"
export * from "./mbManage.vue?vue&type=script&lang=js&"
import style0 from "./mbManage.vue?vue&type=style&index=0&id=391ea1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391ea1c4",
  null
  
)

export default component.exports